import api from 'Application/api/api';

const createStep = (signal, values) =>
	api.post('/step-templates', values, {
		signal,
	});

export default createStep;
